import React from 'react';

const ora = 'h-9 w-full min-w-0 px-2 rounded-lg border border-gray-300 bg-white text-sm disabled:opacity-40';
export const slugZona = (z) => z.toLowerCase().replace(/[^a-z0-9]+/g, '-');

export const FasceZone = ({ zone, scelte, fasce, onToggle, onFascia }) => (
  <div className="space-y-2" data-testid="pulizie-compila-zone">
    <p className="text-xs font-medium">Zone e fascia oraria <span className="font-normal text-gray-500">(orario a caso dentro la fascia)</span></p>
    {zone.map((z) => {
      const on = scelte.includes(z);
      const f = fasce[z];
      return (
        <div key={z} className="grid grid-cols-2 sm:grid-cols-[1fr_6.5rem_6.5rem] gap-1.5 items-center" data-testid={`pulizie-compila-riga-${slugZona(z)}`}>
          <button onClick={() => onToggle(z)} data-testid={`pulizie-compila-zona-${slugZona(z)}`}
            className={`col-span-2 sm:col-span-1 min-w-0 truncate text-left px-3 h-9 rounded-lg text-xs border transition-colors ${on ? 'bg-slate-900 border-slate-900 text-white' : 'border-gray-300 text-gray-500 hover:bg-gray-100'}`}>
            {z}
          </button>
          <input type="time" value={f.da} disabled={!on} onChange={(e) => onFascia(z, { ...f, da: e.target.value })} aria-label={`${z} dalle`}
            className={ora} data-testid={`pulizie-compila-dalle-${slugZona(z)}`} />
          <input type="time" value={f.a} disabled={!on} onChange={(e) => onFascia(z, { ...f, a: e.target.value })} aria-label={`${z} alle`}
            className={ora} data-testid={`pulizie-compila-alle-${slugZona(z)}`} />
        </div>
      );
    })}
  </div>
);
